
import React from 'react'
import Banner from '../home/banner/banner'
import Footer from '../footer/footer'
import RightBtn from '../rightBtn/rightBtn';
import DocumentMeta from 'react-document-meta';
require('./web.scss')
require('./mobile_web.scss')

import { Get, wrapResponse } from './../../requst'

export default class Web extends React.Component {
    static async getInitialProps(ctx) {
        const [data, seo, caseRes, news] = await Promise.all([
            wrapResponse(Get({ url: 'web/banner' })),
            wrapResponse(Get({ url: 'web/seo' })),
            wrapResponse(Get({ url: 'web/case' })),
            wrapResponse(Get({ url: 'web/news' })),
        ])

        const footerProps = await Footer.getInitialProps()

        return { data, seo, case: caseRes, news, footerProps }
    }

    constructor(props, context) {
        super(props, context)
        this.state = {

        }

    }

    componentDidMount() {
        !function (e) {
            function t(a) { if (i[a]) return i[a].exports; var n = i[a] = { exports: {}, id: a, loaded: !1 }; return e[a].call(n.exports, n, n.exports, t), n.loaded = !0, n.exports } var i = {};
            return t.m = e, t.c = i, t.p = "", t(0)
        }([function (e, t) {
            "use strict"; Object.defineProperty(t, "__esModule", { value: !0 });
            var i = window;
            t["default"] = i.flex = function (normal, e, t) {
                var a = e || 100, n = t || 1, r = i.document, o = navigator.userAgent, d = o.match(/Android[\S\s]+AppleWebkit\/(\d{3})/i), l = o.match(/U3\/((\d+|\.){5,})/i), c = l && parseInt(l[1].split(".").join(""), 10) >= 80, p = navigator.appVersion.match(/(iphone|ipad|ipod)/gi), s = i.devicePixelRatio || 1;
                p || d && d[1] > 534 || c || (s = 1); var u = normal ? 1 : 1 / s, m = r.querySelector('meta[name="viewport"]'); m || (m = r.createElement("meta"), m.setAttribute("name", "viewport"), r.head.appendChild(m)), m.setAttribute("content", "width=device-width,user-scalable=no,initial-scale=" + u + ",maximum-scale=" + u + ",minimum-scale=" + u), r.documentElement.style.fontSize = normal ? "50px" : a / 2 * s * n + "px"
            }, e.exports = t["default"]
        }]); flex(false, 100, 1);

        this.setState({ offsetWidth: document.body.offsetWidth })
    }
    case() {
        return this.props.case.map((item, index) => (
            <a href={`/casedetails/${item.id}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} key={index}>
                <img className="Img" style={{ width: '100%' }} src={item.thumb} alt="" />
                <div className="TextBox" style={{ textAlign: 'center' }}>
                    <p>{item.title}</p>
                    {/*<p>{item.desc.substring(0,40)}</p>*/}
                </div>
                <div className="Line"></div>
                <div className="Mask"></div>
            </a>
        ))
    }
    news() {
        return this.props.news.map((item, index) => (
            <a href={`/details/${item.id}`} key={index} >
                <div className="ImgBox">
                    <img className="Img" src={item.thumb} alt="" />
                </div>
                <p className="P_Con P_Head">{item.title}</p>
                <p className="P_Con P_Text">{item.desc}</p>
                <div className="Mask_DeatilsBtm"></div>
                <div className="Triangle"></div>
                <div className="MaskText">
                    <p>{item.created_at.substring(0, 7)}</p>
                    <p>{item.created_at.substring(8, 10)}</p>
                    <img src={require('../../assets/common/images/anniujiantou-bai.png')} alt="" />
                </div>
            </a>
        ))
    }
    render() {
        // console.log(document.body.offsetWidth)
        if (this.state.offsetWidth >= 1200) {
            if (this.props.seo) {
                const meta = {
                    title: this.props.seo.title,
                    description: this.props.seo.description,
                    // link: {
                    //   rel: {
                    //     canonical: 'http://example.com/path/to/sub-page'
                    //   }
                    // },
                    meta: {
                        charSet: 'utf-8',
                        name: {
                            keywords: this.props.seo.keywords
                        },
                    },
                    extend: true
                };
                return (
                    <DocumentMeta {...meta}>
                        <div>
                            <div style={{ width: '100%', height: '630px', display: 'flex', justifyContent: 'center' }}>
                                <img src={this.props.data ? this.props.data[0].photos : null} style={{ height: '100%' }} alt="" />
                            </div>
                            <div className="Web_Middle_one">
                                <div className="ContainerBox">
                                    <p className="Title">服务<span>介绍</span></p>
                                    <p className="SubTitle">丰富的成功经验，年轻化的创作思维，为您创作出精彩的品牌互联网形象</p>
                                    <ul className="Content">
                                        <li>
                                            <div className="True">
                                                <img src={require('../../assets/common/images/fuwujieshao-wangzhanzhengticehua@2x.png')} alt="" />
                                                <p className="TextTitle">网站整体策划</p>
                                                <p className="Text">整体规划/内容策划/技术策划</p>
                                            </div>
                                            <div className="False">
                                                <p className="TextHead">网站整体策划</p>
                                                <p className="TextCont">提供导航策划、内容规划、搜索规划、形象策划、功能规划等内容策划服务；提供开发平台选择、数据库选择、安全策略选择等技术策划服务。</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="True">
                                                <img src={require('../../assets/common/images/fuwujieshao-wangzhansheji@2x.png')} alt="" />
                                                <p className="TextTitle">网站设计</p>
                                                <p className="Text">整体风格设计/界面设计/动画设计</p>
                                            </div>
                                            <div className="False">
                                                <p className="TextHead">网站设计</p>
                                                <p className="TextCont">泛梦科技有着设计水平高超、理论素养深厚、创意出色新颖、实际制作经验丰富的设计团队， 提供从整体风格设计、动画设计、页面设计到导航设计的网站设计服务，专注于为客户提供量 身定做的精品网站。</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="True">
                                                <img src={require('../../assets/common/images/fuwujieshao-wangzhanxitonkaifa@2x.png')} alt="" />
                                                <p className="TextTitle">网站系统开发</p>
                                                <p className="Text">内容管理系统/网上商城系统/论坛系统</p>
                                            </div>
                                            <div className="False">
                                                <p className="TextHead">网站系统开发服务</p>
                                                <p className="TextCont">泛梦科技提供从域名注册、虚拟主机到企业邮箱的网络基础服务；提供网站内容管理系统、论坛系统、网上商城系统、社区管理系统、博客系统、人才招聘系统等网站系统功能开发服务。</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="True">
                                                <img src={require('../../assets/common/images/fuwujieshao-wangzhanynyingweihu@2x.png')} alt="" />
                                                <p className="TextTitle">网站运营维护</p>
                                                <p className="Text">安全管理/文件管理/综合管理</p>
                                            </div>
                                            <div className="False">
                                                <p className="TextHead">网站营运维护服务</p>
                                                <p className="TextCont">泛梦科技提供文件备份、文件恢复及垃圾文件处理等文件管理服务；提供网站个性化管理、统计管理、服务器管理、系统用户管理、人员权限管理、运行环境管理等综合管理服务。</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="Web_Middle_two">
                                <div className="ContainerBox">
                                    <p className="Title">企业智能<span>建站</span></p>
                                    <p className="SubTitle">专为中小企业量身定做的企业智能建站营销系统</p>
                                    <ul className="Content">
                                        <li>
                                            <p className="TextTitle">四站合一节约成本</p>
                                            <p className="Text">只要录入一次数据，四站数据自动同步，降低维护成本；共用一个后台，只要一个虚拟主机，有效节约空间资源。</p>
                                        </li>
                                        <li>
                                            <p className="TextTitle">内置网站优化功能</p>
                                            <p className="Text">网站优化功能包含页面三个标签设置关键词内链自动生成。</p>
                                        </li>
                                        <li>
                                            <p className="TextTitle">操作简单方便 即看即懂</p>
                                            <p className="Text">后台操作简单方便,一看即懂,无需花大量时间学习； 让您更专注于企业网站运营、策划、销售等业务活动。</p>
                                        </li>
                                        <li>
                                            <p className="TextTitle">多语言支持轻松打造国际站</p>
                                            <p className="Text">支持中文、英语、中英双语可自行在后台设置。可作为外 贸网站首选，让您更专注于企业网站运营、策划、销售等 业务活动。</p>
                                        </li>
                                        <li>
                                            <p className="TextTitle">页面精心设计</p>
                                            <p className="Text">页面采用DIV+css布局，并兼容IE7/8/9、兼容Google、 Firefox、搜狗、360等浏览器。</p>
                                        </li>
                                        <li>
                                            <p className="TextTitle">一键备份全站</p>
                                            <p className="Text">内置一键备份全站资料和数据库功能，可以轻松将网 站迁移到另一台服务器。</p>
                                        </li>
                                    </ul>
                                    <img src={require('../../assets/common/images/zhinengjianzhan@2x.png')} alt="" />
                                </div>

                            </div>
                            <div className="Web_Middle_three">
                                <p className="Title">网站开发<span>案例</span></p>
                                <ul className="Content">
                                    {this.props.case ? this.case() : null}
                                </ul>
                                <a href={'/caseshow?key=4'} className="Button" >更多</a>
                            </div>
                            <div className="Web_Process">
                                <div className="ContainerBox">
                                    <p className="Title">网站开发流程</p>
                                    <p className="SubTitle">每个行业我们都有成熟的小程序解决方案</p>
                                    <ul className="Content">
                                        <li>
                                            <img src={require('../../assets/common/images/jichufuwu@2x.png')} alt="" />
                                            <p className="Head">1.基础服务</p>
                                        </li>
                                        <li>
                                            <img src={require('../../assets/common/images/cehuafuwu@2x.png')} alt="" />
                                            <p className="Head">2.策划服务</p>
                                        </li>
                                        <li>
                                            <img src={require('../../assets/common/images/shejifuwu@2x.png')} alt="" />
                                            <p className="Head">3.设计服务</p>
                                        </li>
                                        <li>
                                            <img src={require('../../assets/common/images/gognnengkaifa@2x.png')} alt="" />
                                            <p className="Head">4.功能开发</p>
                                        </li>
                                        <li>
                                            <img src={require('../../assets/common/images/yunyingweihu@2x.png')} alt="" />
                                            <p className="Head">5.运营维护</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            {this.props.news ? <div className="Web_Middle_four">
                                <p className="Title">网站开发<span>资讯</span></p>
                                <p className="SubTitle">强大功能，支撑您社交网站应用更多需求</p>
                                <ul className="Buttom">
                                    {this.news()}
                                </ul>
                                <a href="/newscenter?key=4" >更多</a>
                            </div> : null}
                            <Footer {...this.props.footerProps} />
                            <RightBtn props={this.props} />
                        </div>
                    </DocumentMeta>

                )
            } else {
                return null
            }
        } else {
            return (
                <div className="Mobile_Web">
                    <div className="Mobile_WebBox">
                        <p className="Mobile_Title">服务<span>介绍</span></p>
                        <p className="Mobile_SubTitle">丰富的成功经验，年轻化的创作思维，为您创作出精彩的品牌互联网形象</p>
                        <div className="Mobile_Show">
                            <div>
                                <img src={require('../../assets/common/images/fuwujieshao-wangzhanzhengticehua@3x.png')} alt="" />
                                <p className="Mobile_ShowTitle">网站整体策划</p>
                                <p className="Mobile_ShowText">提供导航策划/内容规划/搜索规划等</p>
                            </div>
                            <div>
                                <img src={require('../../assets/common/images/fuwujieshao-wangzhansheji@3x.png')} alt="" />
                                <p className="Mobile_ShowTitle">网站设计</p>
                                <p className="Mobile_ShowText">整体风格设计/界面设计/动画设计</p>
                            </div>
                            <div>
                                <img src={require('../../assets/common/images/fuwujieshao-wangzhanxitonkaifa@3x.png')} alt="" />
                                <p className="Mobile_ShowTitle">网站系统开发</p>
                                <p className="Mobile_ShowText">内容管理系统/网上商城系统/论坛系统</p>
                            </div>
                            <div>
                                <img src={require('../../assets/common/images/fuwujieshao-wangzhanyunyingweihu@3x.png')} alt="" />
                                <p className="Mobile_ShowTitle">网站运营维护</p>
                                <p className="Mobile_ShowText">安全管理/文件管理/综合管理</p>
                            </div>
                        </div>
                    </div>
                    <div className="Mobile_WebPro">
                        <p className="Mobile_ProTitle">企业智能<span>建站</span></p>
                        <p className="Mobile_ProSubTitle">专为中小企业量身定做的企业智能建站营销系统</p>
                        <img src={require('../../assets/common/images/tu.png')} alt="" />
                        <div className="Mobile_ProTextBox">
                            <div>
                                <img src={require('../../assets/common/images/jieyuechengben.png')} alt="" />
                                <p className="Mobile_ProTextHead">四站合一节约成本</p>
                            </div>
                            <p className="Mobile_ProTextContent">降低维护成本；有效节约空间资源。</p>
                        </div>
                        <div className="Mobile_ProTextBox">
                            <div>
                                <img src={require('../../assets/common/images/caozuojiandan.png')} alt="" />
                                <p className="Mobile_ProTextHead">操作简单方便 即看即懂</p>
                            </div>
                            <p className="Mobile_ProTextContent">无需花大量时间学习；使更专注于企业网站运营、策划等活动。</p>
                        </div>
                        <div className="Mobile_ProTextBox">
                            <div>
                                <img src={require('../../assets/common/images/jinxinsheji.png')} alt="" />
                                <p className="Mobile_ProTextHead">页面精心设计</p>
                            </div>
                            <p className="Mobile_ProTextContent">兼容IE7/8/9、兼容Google、 Firefox、搜狗、360等浏览器。</p>
                        </div>
                        <div className="Mobile_ProTextBox">
                            <div>
                                <img src={require('../../assets/common/images/youhuagognenng.png')} alt="" />
                                <p className="Mobile_ProTextHead">内置网站优化功能</p>
                            </div>
                            <p className="Mobile_ProTextContent">网站优化功能包含页面三个标签设置关键词内链自动生成。</p>
                        </div>
                        <div className="Mobile_ProTextBox">
                            <div>
                                <img src={require('../../assets/common/images/duoyuyan.png')} alt="" />
                                <p className="Mobile_ProTextHead">多语言支持轻松打造国际站</p>
                            </div>
                            <p className="Mobile_ProTextContent">支持中文、英语、中英双语可自行在后台设置。</p>
                        </div>
                        <div className="Mobile_ProTextBox">
                            <div>
                                <img src={require('../../assets/common/images/beifenquanzhan.png')} alt="" />
                                <p className="Mobile_ProTextHead">一键备份全站</p>
                            </div>
                            <p className="Mobile_ProTextContent">内置一键备份全站资料和数据库功能。</p>
                        </div>
                    </div>
                </div>
            )
        }

    }
}